import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerService } from '../../core/partner.service';
import { SupportNumber } from '../support_phone_number';
import { PREMIUM_SUPPORT_SUBSCRIPTION_TIERS, STANDARD_SUPPORT_TIERS } from '@galaxy/partner';

@Injectable({ providedIn: 'root' })
export class SupportNumberService {
  constructor(private readonly partnerService: PartnerService) {}

  public getSupportNumber(): Observable<string> {
    return this.partnerService.partnerConfig$.pipe(
      map((partnerConfig) => {
        if (PREMIUM_SUPPORT_SUBSCRIPTION_TIERS.includes(partnerConfig.subscription_tier)) {
          return SupportNumber.PREMIUM_SUPPORT_NUMBER;
        }

        if (STANDARD_SUPPORT_TIERS.includes(partnerConfig.subscription_tier)) {
          return SupportNumber.STANDARD_PRIORITY_SUPPORT_NUMBER;
        }

        return '';
      }),
    );
  }
}
